import * as React from "react";
import { DataGrid, GridColDef, GridValueGetterParams } from "@mui/x-data-grid";
import WarningAmberRoundedIcon from "@mui/icons-material/WarningAmberRounded";
import { Box, Button, Grid, Tooltip } from "@mui/material";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { Formik } from "formik";
import MaterialTextFieldComponent from "../../components/textField/MaterialTextFieldCmp";
import Pagination from "@mui/material/Pagination";
import PaginationItem from "@mui/material/PaginationItem";
import { ColumnModel, PageInfoModel } from "../../models/common.model";
import { PaginationInfo } from "../../models/loan.model";
import { useMutation } from "react-query";
import {
  CreateNewPayment,
  GetLoansReadyForSettlement,
  GetWalletInfo,
} from "../../services/supplierPayment.service";
import {
  CreateNewPaymentRequest,
  GetLoansReadyForSettlementResponse,
  GetWalletInfoResponse,
} from "../../models/supplierPayment.model";
import { toast } from "react-toastify";
import ModalSettlementPayment from "../../components/modals/ModalSettlementPayment";
import { getTokenClaims } from "../../services/auth.service";
import ErrorPage from "../errorPage/errorPage";
import { createStyles, makeStyles } from "@material-ui/core";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import PlaylistAddIcon from "@mui/icons-material/PlaylistAdd";
import { useEffect, useState } from "react";
import { useHistory, withRouter } from "react-router-dom";
import { stringify } from "querystring";
import { keys } from "lodash";
import { useSelector } from "react-redux";

const useStyles = makeStyles((theme) =>
  createStyles({
    select: {
      "&.Mui-selected": {
        backgroundColor: muiSelected,
      },
    },
  })
);

//c
const columns: readonly ColumnModel[] = [
  { id: "customerName", label: "نام و نام خانوادگی" },
  { id: "customerNationalCode", label: "کد ملی" },
  {
    id: "requestDate_Persian",
    label: "تاریخ درخواست",
  },
  {
    id: "customerMobileNumber",
    label: "شماره موبایل",
  },

  {
    id: "loanAmount",
    label: "مبلغ تسهیلات (ریال)",
    hasFormat: true,
    format: (value: number) => {
      return value.toLocaleString("fa");
    },
  },
  {
    id: "settlementAmount",
    label: "مبلغ تسویه (ریال)",
    hasFormat: true,
    format: (value: number) => {
      return value.toLocaleString("fa");
    },
  },
  {
    id: "assignedDate_Persian",
    label: "تاریخ اعطای تسهیلات",
  },
  {
    id: "financialSupplierTitle",
    label: "منبع مالی",
  },
  {
    id: "supplierUser",
    label: "کاربر پذیرنده",
  },
  {
    id: "supplierUserMobile",
    label: "شماره موبایل کاربر پذیرنده",
  },
  {
    id: "loanTemplateTitle",
    label: "عنوان طرح",
  },
];
const nextIcon = () => {
  return (
    <img style={{ height: "12px", width: "10px" }} src="images/Next.png" />
  );
};
const previusIcon = () => {
  return (
    <img style={{ height: "12px", width: "10px" }} src="images/Previous.png" />
  );
};
let muiSelected: any;
export default function ReadyForPayment() {
  const hasWalletAccess = String(getTokenClaims()?.hasWalletAccess);
  const temp = {} as GetLoansReadyForSettlementResponse[];
  const [rows, setRows] = React.useState<GetLoansReadyForSettlementResponse[]>(
    []
  );
  const [data, setData] = React.useState<GetLoansReadyForSettlementResponse[]>(
    []
  );
  const jsonFile = useSelector((state: any) => state.style);
  muiSelected = jsonFile?.muiSelected;
  const [settlementAmount, setSettlementAmount] = React.useState<number>(0);
  const [walletInfo, setWalletInfo] = React.useState<GetWalletInfoResponse>();
  const [total, setTotal] = React.useState<number>(0);
  const [formValues, setFormValues] = React.useState<CreateNewPaymentRequest>();
  const [openPaymentModal, setOpenPaymentModal] = React.useState<boolean>(
    false
  );
  const [loanRefKeys, setLoanRefKeys] = React.useState<any[]>([]);
  const [selectedRows, setSelectedRows] = React.useState<any>([]);
  const [pageInfo, setPageInfo] = React.useState<PageInfoModel>(
    (): PageInfoModel => {
      let pageInfoModel = new PageInfoModel();
      pageInfoModel.pageNumber = -1;
      pageInfoModel.pageSize = 10;
      pageInfoModel.total = 0;

      return pageInfoModel;
    }
  );
  const [currentPaginationInfo, setCurrentPaginationInfo] = React.useState(
    (): PaginationInfo => {
      let paginationInfo = new PaginationInfo();
      paginationInfo.pageNumber = 1;
      return paginationInfo;
    }
  );
  const { mutate: GetLoansReadyForSettlementMutate } = useMutation(
    GetLoansReadyForSettlement,
    {
      onSuccess: (data: GetLoansReadyForSettlementResponse[]) => {
        if (data) {
          setRows(data);
          setData(data);
        }
      },
    }
  );
  const { mutate: GetWalletInfoMutate } = useMutation(GetWalletInfo, {
    onSuccess: (data: GetWalletInfoResponse) => {
      if (data) {
        setWalletInfo(data);
      }
    },
  });

  const changePageNumber = (newPageNumber: number) => {
    currentPaginationInfo.pageNumber = newPageNumber;
    setCurrentPaginationInfo(currentPaginationInfo);
  };
  const handleChangePagination = (event: any, value: any) => {
    changePageNumber(value);
  };
  const css = `
.Mui-selected{
    background: #bbdff9 !important;
};
.super-app-theme--header
{
    background: red !important;
}.
`;
  React.useEffect(() => {
    GetLoansReadyForSettlementMutate();
    GetWalletInfoMutate();
  }, []);
  const initialValues = {} as CreateNewPaymentRequest;
  const classes = useStyles();
  const [playlistData, setPlaylistData] = React.useState<
    GetLoansReadyForSettlementResponse[]
  >([]);

  function addAllData() {
    setPlaylistData(data);
    setRows([]);

    let keys: any[] = loanRefKeys;
    rows.map((item: any) => {
      setSettlementAmount((prev: any) => prev + item.settlementAmount);
      keys.push(item.referenceKey);
    });
    setLoanRefKeys(keys);
  }

  function removeAllData() {
    setPlaylistData([]);
    setRows(data);
    setSettlementAmount(0);
    setLoanRefKeys([]);
  }

  let listData: any = playlistData;
  let keys: any[] = loanRefKeys;
  function addInPlayList(value: any) {
    listData.push(value);
    setPlaylistData(listData);
    let filter = rows.filter(
      (item: any) => item.referenceKey !== value.referenceKey
    );
    setRows(filter);
    let amount = settlementAmount
      ? settlementAmount + value.settlementAmount
      : value.settlementAmount;
    setSettlementAmount(amount);
    keys.push(value.referenceKey);
    setLoanRefKeys(keys);
  }

  function removeFromPlayList(value: any) {
    let add = rows;
    add.push(value);
    setRows(add);
    let filter = playlistData.filter(
      (item: any) => item.referenceKey !== value.referenceKey
    );
    setPlaylistData(filter);
    let amount = settlementAmount
      ? settlementAmount - value.settlementAmount
      : value.settlementAmount;
    setSettlementAmount(amount);
    let keys = loanRefKeys.filter((item: any) => item !== value.referenceKey);
    setLoanRefKeys(keys);
  }
  let exportExcel = () => {
    // ExportLoanRegisterRequestsMutation.mutate(
    //   valueFilterData ? valueFilterData! : new FilterRegister()
    // );
  };

  const history = useHistory<{
    from: string;
    id: string;
    pageNumber: number;
    clickOnBack: boolean;
  }>();

  const handleDetail = (key: string) => {
    history.push({
      pathname: `/Payment/paymentRequestInfo`,
      state: {
        id: key,
        from: "",
        pageNumber: 1,
        clickOnBack: false,
      },
    });
  };
  const onClickSettlementType = () => {};

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={(values) => {
        values.loanRefKeys = loanRefKeys;
        setOpenPaymentModal(true);
        setFormValues(values);
        // if (
        //   requestDate != null &&
        //   (requestDate[0] != undefined || requestDate[1] != undefined)
        // ) {
        //   values.requestDateFrom = convertToLocalDateTime(
        //     Number(requestDate[0])
        //   );
        //   if (requestDate?.length > 1) {
        //     values.requestDateTo = convertToLocalDateTime(
        //       Number(requestDate[1])
        //     );
        //   } else {
        //     values.requestDateTo = convertToLocalDateTime(
        //       Number(requestDate[0])
        //     );
        //   }
        // } else {
        //   values.requestDateTo = undefined;
        //   values.requestDateFrom = undefined;
        // }
        // if (
        //   statusDate != null &&
        //   (statusDate[0] != undefined || statusDate[1] != undefined)
        // ) {
        //   values.statusDateFrom = convertToLocalDateTime(
        //     Number(statusDate[0])
        //   );
        //   if (statusDate?.length > 1) {
        //     values.statusDateTo = convertToLocalDateTime(
        //       Number(statusDate[1])
        //     );
        //   } else {
        //     values.statusDateTo = convertToLocalDateTime(
        //       Number(statusDate[0])
        //     );
        //   }
        // } else {
        //   values.statusDateFrom = undefined;
        //   values.statusDateTo = undefined;
        // }
        //
      }}
    >
      {({
        handleSubmit,
        handleChange,
        values,
        errors,
        touched,
        handleBlur,
      }) => (
        <form onSubmit={handleSubmit}>
          <div className="row">
            {/* <div
                    className="col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12"
                    style={{ marginTop: "1vh" }}
                  >
                    <MaterialTextFieldComponent
                      // className="shadowTextField"
                      helperText={""}
                      placeHolder={"نام و نام خانوادگی متقاضی"}
                      label={"نام و نام خانوادگی متقاضی"}
                      required={false}
                      value={valueCustomerFullName}
                      onChange={changeValueCustomerFullName}
                      name="customerFullName"
                      id="customerFullName"
                    />
                  </div>
                  <div
                    className="col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12"
                    style={{ marginTop: "1vh" }}
                  >
                    <MaterialTextFieldComponent
                      // className="shadowTextField"
                      helperText={""}
                      placeHolder={"کد ملی"}
                      label={"کد ملی "}
                      required={false}
                      value={valueCustomerNationalCode}
                      onChange={changeValueCustomerNationalCode}
                      name="customerNationalCode"
                      id="customerNationalCode"
                    />
                  </div>
                  <div
                    className="col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12"
                    style={{ marginTop: "1vh" }}
                  >
                    <MaterialTextFieldComponent
                      // className="shadowTextField"
                      helperText={""}
                      placeHolder={"شماره همراه"}
                      label={"شماره همراه"}
                      required={false}
                      value={valueCustomerMobileNumber}
                      onChange={changeValueCustomerMobileNumber}
                      name="customerMobileNumber"
                      id="customerMobileNumber"
                    />
                  </div>
                  <div
                    className="col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12"
                    style={{ marginTop: "1vh" }}
                  >
                    <CacheProvider value={cacheRtl}>
                      <ThemeProvider theme={theme}>
                        <div dir="rtl">
                          <MultiSelectChip
                            id="loanRequestStatus"
                            name="loanRequestStatus"
                            value={valueMultiSelect}
                            label="وضعیت درخواست"
                            options={loanRequestStatus}
                            onChange={changeMultiSelectChip}
                            changeMultiSelect={changeMultiSelectChip}
                          />
                        </div>
                      </ThemeProvider>
                    </CacheProvider>
                  </div>
                  <div
                    className="col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12"
                    style={{ marginTop: "1vh" }}
                  >
                    <FormControl fullWidth className="shadowDatepicker">
                      <DatePickerComponents
                        valueArray={requestDate}
                        label={"تاریخ درخواست"}
                        // onChange={(newValue: any) => {
                        //   setRequestDateFrom(newValue);
                        // }}
                        onChange={changeValueRequestDate}
                        range={true}
                      />
                    </FormControl>
                  </div>
                  <div
                    className="col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12"
                    style={{ marginTop: "1vh" }}
                  >
                    <FormControl fullWidth className="shadowDatepicker">
                      <DatePickerComponents
                        valueArray={statusDate}
                        label={"تاریخ آخرین وضعیت "}
                        // onChange={(newValue: any) => {
                        //   setStatusDateFrom(newValue);
                        // }}
                        onChange={changeValueStatusDate}
                        range={true}
                      />
                    </FormControl>
                  </div> */}
            {/* <div
                    className="col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12"
                    style={{ marginTop: "1vh" }}
                  >
                    <CacheProvider value={cacheRtl}>
                      <ThemeProvider theme={theme}>
                        <div dir="rtl">
                          <Autocomplate
                            id="loanTemplateIds"
                            name="loanTemplateIds"
                            value={valueLoanTemplateOptions}
                            label="طرح تسهیلات"
                            options={loanTemplateOptions}
                            onChange={changeValueLoanTemplateOptions}
                            changeMultiSelect={changeValueLoanTemplateOptions}
                            responseValue={valueLoanTemplate}
                          />
                        </div>
                      </ThemeProvider>
                    </CacheProvider>
                  </div> */}
            {/* <div
                    className=" col-4  col-lg-2 butFilter"
                    style={{ marginTop: "1vh" }}
                  >
                    <Button
                      fullWidth
                      variant="contained"
                      type="submit"
                      className="btnForm SuccessDefault  "
                    >
                      اعمال فیلتر
                    </Button>
                  </div> */}
          </div>
          {/* {valueMultiSelect?.length ||
                  valueSupplierSettlementStatus?.length ||
                  valueLoanTemplateOptions?.length ||
                  valueLoanRequestSources?.length ||
                  valueSupplierUserOptions?.length ||
                  valueCustomerFullName ||
                  valueCustomerNationalCode ||
                  valueCustomerMobileNumber ||
                  valueRequestDate ||
                  valueStatusDate ? (
                  <div className="row tableCMP">
                    <Button
                      onClick={deleteChip}
                      style={{
                        justifyContent: "right",
                        minWidth: "25px",
                        marginRight: "-1vh",
                      }}
                    >
                      <img
                        style={{ height: "24px", width: "24px" }}
                        src="images/RemoveAllFilters.svg"
                      />
                    </Button>
                    <ChipCmp
                      item={valueMultiSelect}
                      enamValue={loanRequestStatus}
                      index={valueMultiSelect?.length}
                      setChildValue={setChildValueStat}
                    />
                    <ChipCmp
                      item={valueLoanTemplateOptions}
                      enamValue={loanTemplateOptions}
                      index={valueLoanTemplateOptions?.length}
                      setChildValue={setChildValueLoanTemplate}
                    />
                    <ChipCmp
                      item={valueCustomerFullName}
                      enamValue={valueCustomerFullName}
                      index={valueCustomerFullName?.length}
                      setChildValue={setChildValueCustomerFullName}
                    />
                    <ChipCmp
                      item={valueCustomerNationalCode}
                      enamValue={valueCustomerNationalCode}
                      index={valueCustomerNationalCode?.length}
                      setChildValue={setChildValueCustomerNationalCode}
                    />
                    <ChipCmp
                      item={valueCustomerMobileNumber}
                      enamValue={valueCustomerMobileNumber}
                      index={valueCustomerMobileNumber?.length}
                      setChildValue={setChildValueCustomerMobileNumber}
                    />
                    <ChipCmp
                      item={valueRequestDate}
                      enamValue={valueRequestDate}
                      index={valueRequestDate?.length}
                      setChildValue={setChildValueRequestDate}
                    />
                    <ChipCmp
                      item={valueStatusDate}
                      enamValue={valueStatusDate}
                      index={valueStatusDate?.length}
                      setChildValue={setChildValueStatusDate}
                    />
                  </div>
                ) : (
                  ""
                )} */}
          {/* </form>
          )}
        </Formik>
      </Box>   <br />*/}

          <>
            <div
              className="cardTableBorder tabsScrollModalVehicle"
              style={{
                height: "370px",
                maxHeight: "334px",
                marginBottom: "35px",
              }}
            >
              <TableContainer
                style={{
                  background: "#fff",
                  // maxHeight: "30vh"
                  height: "310px",
                  maxHeight: "334px",
                }}
                // className="boxScrollSubmit "
              >
                <Table
                  stickyHeader
                  aria-label="sticky table"
                  style={{ borderCollapse: "collapse" }}
                >
                  <TableHead
                    className="rowTHead"
                    style={{ paddingBottom: "10px" }}
                  >
                    <TableRow
                      classes={{ root: classes.select }}
                      className={`${classes} borderRight borderLeft `}
                      // selected={selectedRow === 0}
                    >
                      <TableCell
                        className="rowTHead colorTitle textFont12 fontWeight stickyColO"
                        // align="right"
                        style={{ width: "10vh", minWidth: "10vh" }}
                      >
                        <Button
                          className=" colorTitle textFont12 fontWeight "
                          onClick={() => {
                            addAllData();
                          }}
                          style={{
                            textAlign: "center",
                            fontWeight: "bolder",
                          }}
                        >
                          <Tooltip arrow title="انتخاب همه">
                            <PlaylistAddIcon
                              style={{ background: "transparent" }}
                            />
                          </Tooltip>
                        </Button>
                      </TableCell>
                      {columns.map((column) => (
                        <TableCell
                          className="rowTHead colorTitle textFont12 fontWeight noWrap"
                          key={column.id}
                          align="right"
                          style={{
                            width: "20vh",
                            minWidth: "20vh",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {column.label}
                        </TableCell>
                      ))}
                      {/* <TableCell
                              className="rowTHead colorTitle stickyColO "
                              align="right"
                            >
                              <MoreHorizIcon
                                scale="scale(1.8) "
                                style={{ color: "#1D4A87" }}
                              />
                            </TableCell> */}
                    </TableRow>
                  </TableHead>
                  <div style={{ width: "100%", height: "10px" }}></div>
                  <TableBody>
                    {rows
                      ? rows?.map((row, rowIndex) => {
                          return (
                            <TableRow
                              classes={{ root: classes.select }}
                              className={`${
                                rowIndex % 2 == 0 ? "rowTBodyE  " : "rowTBodyO "
                              } ${classes} borderRight borderLeft  noWrap`}
                              hover
                              role="checkbox"
                              tabIndex={-1}
                              style={{ whiteSpace: "nowrap" }}
                              // key={row.loanRequestId}
                              // selected={selectedRow === rowIndex}
                            >
                              {/* <TableCell
                            className="textFont12"
                            style={{ width: "10vh", minWidth: "10vh" }}
                          >
                            {((currentPaginationInfo.pageNumber ?? 0) - 1) *
                              (currentPaginationInfo.pageSize! ?? 0) +
                              rowIndex +
                              1}
                          </TableCell> */}
                              <TableCell
                                className={`colorTitle textFont12 fontWeight backgroundColorTransparet ${
                                  rowIndex % 2 == 0
                                    ? " stickyColO   "
                                    : "stickyColE"
                                }`}
                                align="right"
                                style={{
                                  width: "10vh",
                                  minWidth: "10vh",
                                  textAlign: "center",
                                  fontWeight: "bolder",
                                }}
                              >
                                <Button
                                  className=" colorTitle textFont12 fontWeight "
                                  onClick={() => {
                                    addInPlayList(row);
                                  }}
                                  style={{
                                    textAlign: "center",
                                    fontWeight: "bolder",
                                  }}
                                >
                                  <PlaylistAddIcon
                                    style={{ background: "transparent" }}
                                  />
                                </Button>
                              </TableCell>
                              {columns.map((column) => {
                                const value =
                                  row[
                                    column.id as keyof GetLoansReadyForSettlementResponse
                                  ];
                                return (
                                  <TableCell
                                    className="textFont12"
                                    key={column.id}
                                    align="right"
                                  >
                                    {column.format && column.hasFormat
                                      ? column.format(value)
                                      : value?.toString()}
                                  </TableCell>
                                );
                              })}
                              {/* <TableCell
                                    className={
                                      rowIndex % 2 == 0
                                        ? " stickyColO   "
                                        : " stickyColE  "
                                    }
                                  >
                                    <MoreHorizIcon
                                      scale="scale(1.8) "
                                      className="cursorPointer"
                                      style={{ color: "#1D4A87" }}
                                    onClick={() =>
                                      handleDetail(row?.key!)
                                    }
                                    />
                                  </TableCell> */}
                            </TableRow>
                          );
                        })
                      : null}
                  </TableBody>
                </Table>
              </TableContainer>
            </div>
            <span
              style={{
                color: "#1D4A87",
                fontSize: "16px",
                fontWeight: "bold",
                marginRight: "15px",
              }}
            >
              <span
                style={{
                  color: "#1D4A87",
                  fontSize: "16px",
                  fontWeight: "bold",
                }}
              >
                لیست منتخب تسویه{" "}
                <span
                  style={{
                    color: "#1D4A87",
                    fontSize: "14px",
                    fontWeight: "normal",
                  }}
                >
                  (
                  {playlistData.length !== undefined &&
                  playlistData.length != null
                    ? playlistData.length
                    : 0}{" "}
                  مورد){" "}
                </span>
              </span>
            </span>
            <div
              className="cardTableBorder tabsScrollModalVehicle"
              style={{
                height: "360px",
                maxHeight: "330px",
                marginBottom: "20px",
              }}
            >
              <TableContainer
                style={{
                  background: "#fff",
                  // maxHeight: "30vh"
                  height: "305px",
                  maxHeight: "330px",
                }}
                // className="boxScrollSubmit "
              >
                <Table
                  stickyHeader
                  aria-label="sticky table"
                  style={{ borderCollapse: "collapse" }}
                >
                  <TableHead
                    className="rowTHead"
                    style={{ paddingBottom: "10px" }}
                  >
                    <TableRow
                      classes={{ root: classes.select }}
                      className={`${classes} borderRight borderLeft`}
                      // selected={selectedRow === 0}
                    >
                      <TableCell
                        className="rowTHead colorTitle textFont12 fontWeight stickyColO"
                        align="right"
                        style={{ width: "10vh", minWidth: "10vh" }}
                      >
                        <Button
                          className=" colorTitle textFont12 fontWeight"
                          onClick={() => {
                            removeAllData();
                          }}
                          style={{
                            textAlign: "center",
                            fontWeight: "bolder",
                          }}
                        >
                          <Tooltip arrow title="لغو همه">
                            <img
                              onClick={exportExcel}
                              className="cursorPointer"
                              style={{
                                width: "17px",
                                height: "17px",
                                marginBottom: ".5vh",
                                background: "transparent",
                              }}
                              src="images/RemoveFromPlaylist.svg"
                            />
                          </Tooltip>
                        </Button>
                      </TableCell>
                      {columns.map((column) => (
                        <TableCell
                          className="rowTHead colorTitle textFont12 fontWeight noWrap"
                          key={column.id}
                          align="right"
                          style={{ width: "20vh", minWidth: "20vh" }}
                        >
                          {column.label}
                        </TableCell>
                      ))}
                      {/* <TableCell
                              className="rowTHead colorTitle stickyColO "
                              align="right"
                            >
                              <MoreHorizIcon
                                scale="scale(1.8) "
                                style={{ color: "#1D4A87" }}
                              />
                            </TableCell> */}
                    </TableRow>
                  </TableHead>
                  <div style={{ width: "100%", height: "10px" }}></div>
                  <TableBody>
                    {playlistData
                      ? playlistData.map((row, rowIndex) => {
                          return (
                            <TableRow
                              classes={{ root: classes.select }}
                              className={`${
                                rowIndex % 2 == 0 ? "rowTBodyE  " : "rowTBodyO "
                              } ${classes} borderRight borderLeft  noWrap`}
                              hover
                              role="checkbox"
                              tabIndex={-1}
                              // key={row.loanRequestId}
                              // selected={selectedRow === rowIndex}
                              style={{ whiteSpace: "nowrap" }}
                            >
                              {/* <TableCell
                            className="textFont12"
                            style={{ width: "10vh", minWidth: "10vh" }}
                          >
                            {((currentPaginationInfo.pageNumber ?? 0) - 1) *
                              (currentPaginationInfo.pageSize! ?? 0) +
                              rowIndex +
                              1}
                          </TableCell> */}
                              <TableCell
                                className={` colorTitle textFont12 fontWeight backgroundColorTransparet ${
                                  rowIndex % 2 == 0
                                    ? " stickyColO   "
                                    : "stickyColE"
                                }`}
                                align="right"
                                style={{
                                  width: "10vh",
                                  minWidth: "10vh",
                                  textAlign: "center",
                                  fontWeight: "bolder",
                                }}
                              >
                                <Button
                                  className=" colorTitle textFont12 fontWeight "
                                  onClick={() => {
                                    removeFromPlayList(row);
                                  }}
                                  style={{
                                    textAlign: "center",
                                    fontWeight: "bolder",
                                  }}
                                >
                                  <img
                                    onClick={exportExcel}
                                    className="cursorPointer"
                                    style={{
                                      width: "17px",
                                      height: "17px",
                                      marginBottom: ".5vh",
                                      background: "transparent",
                                    }}
                                    src="images/RemoveFromPlaylist.svg"
                                  />
                                </Button>
                              </TableCell>
                              {columns.map((column) => {
                                const value =
                                  row[
                                    column.id as keyof GetLoansReadyForSettlementResponse
                                  ];
                                return (
                                  <TableCell
                                    className="textFont12 nowrapClass"
                                    key={column.id}
                                    align="right"
                                  >
                                    {column.format && column.hasFormat
                                      ? column.format(value)
                                      : value?.toString()}
                                  </TableCell>
                                );
                              })}
                              {/* <TableCell
                                    className={
                                      rowIndex % 2 == 0
                                        ? " stickyColO   "
                                        : " stickyColE  "
                                    }
                                  >
                                    <MoreHorizIcon
                                      scale="scale(1.8) "
                                      className="cursorPointer"
                                      style={{ color: "#1D4A87" }}
                                    onClick={() =>
                                      handleDetail(row?.key!)
                                    }
                                    />
                                  </TableCell> */}
                            </TableRow>
                          );
                        })
                      : null}
                  </TableBody>
                </Table>
              </TableContainer>
            </div>

            <div style={{ paddingBottom: "5px" }}>
              <Grid
                container
                xs={12}
                spacing={1}
                columns={{ xs: 2, sm: 8, md: 12 }}
              >
                <Grid
                  item
                  xs={6}
                  md={6}
                  sm={6}
                  style={{
                    textAlign: "left",
                    color: "#004BFE",
                    fontWeight: "bold",
                    marginTop: "10px",
                  }}
                >
                  مبلغ قابل برداشت:{" "}
                  {walletInfo?.balanceAmount! <
                  walletInfo?.maximumDailyWithdrawalAmount!
                    ? walletInfo?.balanceAmount.toLocaleString("fa")
                    : walletInfo?.maximumDailyWithdrawalAmount.toLocaleString(
                        "fa"
                      )}{" "}
                  ریال
                </Grid>

                <Grid
                  item
                  xs={4}
                  md={4}
                  sm={9}
                  style={{
                    direction: "rtl",
                    marginTop: "9px",
                    borderRadius: "5px",
                    backgroundColor: "#F9FAFC",
                    border: "1px solid #DAE0E4",
                  }}
                >
                  <Grid container xs={12}>
                    <Grid item xs={4} style={{ textAlign: "right" }}>
                      &nbsp; &nbsp;{" "}
                      <span style={{ color: "#1D4A87" }}>جمع کل (ریال):</span>
                    </Grid>
                    <Grid item xs={8} style={{ textAlign: "end" }}>
                      &nbsp; &nbsp;{" "}
                      <span style={{ color: "#1D4A87", fontWeight: "bold" }}>
                        {settlementAmount
                          ? settlementAmount!.toLocaleString()
                          : ""}
                      </span>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid
                  item
                  xs={2}
                  md={2}
                  sm={1}
                  style={{
                    right: "2px",
                    position: "relative",
                    textAlign: "end",
                  }}
                >
                  <Button
                    type="submit"
                    // onClick={onClickSettlementType}
                    disabled={settlementAmount === 0 ? true : false}
                    className={
                      settlementAmount === 0
                        ? "btnForm disabledBtn  "
                        : "btnForm SuccessDefault "
                    }
                    style={{ width: "170px" }}
                  >
                    تایید و ثبت درخواست
                  </Button>
                </Grid>
              </Grid>
            </div>
            {/* <div>
            <div className="row"></div>
            <Grid container xs={12}>
              <Grid item xs={4}>
                <span
                  style={{ color: "#1D4A87", top: "1vh", position: "relative" }}
                >
                  تعداد کل :
                  <span style={{ color: "#01AF43" }}>{pageInfo.total}</span>{" "}
                  مورد
                </span>
              </Grid>
              <Grid item xs={4}>
                <Pagination
                  renderItem={(item) => (
                    <PaginationItem
                      components={{
                        previous: previusIcon,
                        next: nextIcon,
                      }}
                      {...item}
                    />
                  )}
                  // color="primary"
                  sx={{
                    display: "flex",
                    justifyContent: "center !important",
                    direction: "ltr",
                    margin: "5px",
                    button: {
                      color: "#25D1C9",
                      fontSize: "14px !important",
                      fontFamily: "iranSans",
                    },
                    //  button.sele
                  }}
                  count={
                    pageInfo ? Math.ceil(pageInfo.total / pageInfo.pageSize) : 0
                  }
                  onChange={handleChangePagination}
                  page={currentPaginationInfo.pageNumber}
                />
              </Grid>
              <Grid item xs={4}></Grid>
            </Grid>
          </div> */}
          </>

          <ModalSettlementPayment
            openModel={openPaymentModal}
            setOpenPaymentModal={setOpenPaymentModal}
            price={settlementAmount}
            formValues={formValues!}
          />
        </form>
      )}
    </Formik>
  );
}
